import { Image, Space, Typography } from 'antd';
import { FC, Fragment } from 'react';

import { IUserItemProps } from './types';

const { Title, Paragraph } = Typography;

const UserItem: FC<IUserItemProps> = ({ circle, name, url, info }) => {
  return (
    <Space size={16} align="start">
      <Image
        src={url}
        width={circle ? 148 : 240}
        height={circle ? 148 : 138}
        preview={false}
        style={{ objectFit: 'cover', borderRadius: circle ? '50%' : 10 }}
      />
      <div>
        <Title level={4}>{name}</Title>
        {info.map(item =>
          typeof item === 'string' ? (
            <Paragraph key={`info-item-${item}`} style={{ marginBottom: 4 }}>
              {item}
            </Paragraph>
          ) : (
            <Fragment key={`info-item-${item}`}>{item}</Fragment>
          )
        )}
      </div>
    </Space>
  );
};

export default UserItem;
